import { HeadCell } from '../../types/table';
import { ISubscriptionRowData } from '../../types/subscription';

const subscriptionHeaderCells: HeadCell<ISubscriptionRowData>[] = [
  { id: 'subscriptionId', label: 'Subscription ID', key: 'subscriptionId' },
  { id: 'system', label: 'System', key: 'system' },
  { id: 'roleName', label: 'Role', key: 'roleName' },
  { id: 'actions', label: 'Actions' },
];

export default subscriptionHeaderCells;
